import { createContext } from 'react';
import { ClientDTO } from 'wisestep-api';

export const BulkImportContext = createContext({
  getClientData: () => [] as ClientDTO[],
  setBulkImport: (data) => localStorage.setItem('clientData', JSON.stringify(data)),
});

export const BulkImportProvider = ({ children }) => {
  const getClientData = () => JSON.parse(localStorage.getItem('clientData') ?? '');

  const setBulkImport = (data) => localStorage.setItem('clientData', JSON.stringify(data));

  return (
    <BulkImportContext.Provider value={{ getClientData, setBulkImport }}>
      {children}
    </BulkImportContext.Provider>
  );
};
